import MyPhotoAPI from '@/api/myPhoto'
import Socket from '@/socket'

// state
const _state = {
  submitting: false,
}

// getters
const _getters = {
}

// mutations
const mutations = {
  SET_SUBMITTING(state, submitting) {
    state.submitting = submitting
  },
}

// actions
const actions = {
  async uploadImageAction({ rootState }, file) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('socketId', Socket?.getSocketId())
    formData.append('accessCode', rootState?.presentation?.uniqueAccessCode)

    return MyPhotoAPI.uploadImage(formData)
  },
  async deleteImageAction({ commit }, params) {
    commit('SET_SUBMITTING', true)
    await MyPhotoAPI.deleteImage(params)
    commit('SET_SUBMITTING', false)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
